module.exports = __webpack_public_path__ + "media/box/product_not_found-2dc0a262.svg";